export default __webpack_public_path__ + "static/media/tracking_banner_img.6d1cf7ed.png";